module.exports = __webpack_public_path__ + "img/for-review-blue.be08222b.svg";